import { useFilterReferralContext } from "./filter-referral.context";

export function FilterReferral() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterReferralContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}